// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SGIc","index":"styles_index__2hClY"};